module.exports = __webpack_public_path__ + "media/toaster-ad7aec6f.gif";